var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpm-wrapper"},[_c('el-tooltip',{attrs:{"effect":"dark","placement":"top","trigger":"hover","content":_vm.tip}},[_c('div',[_c('img',{staticClass:"question",attrs:{"src":require('@/assets/img/question-icon.png'),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }